import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler } from '@angular/core';

import { ErrorCustomHandler } from '@core/modules/error/error-custom-handler';
import { ErrorService } from '@core/modules/error/services/error.service';

import { ErrorInterceptor } from '@core/modules/error/interceptors/error.interceptor';

export const ERROR_CONFIG_PROVIDERS = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptor,
    multi: true,
  },
  {
    provide: ErrorHandler,
    useClass: ErrorCustomHandler,
    deps: [ErrorService],
  },
];
